import { useTranslation } from "react-i18next";
import { LeftSocialMediaIconUI } from "../components/LeftSocialMediaIconUI";
import { UttaranServicesLeftMenuList } from "../utils/constants";
import { RenderNavItem } from "../components/RenderNavItem";
import { DownloadFileByFileStoreId } from "../components/DownloadFileByFileStoreId";

const BSUP = () => {
  const { t } = useTranslation();

  return (
    <>
      <section id="hero" className="hero hero2">
        <LeftSocialMediaIconUI />

        <div className="carousel-item active">
          <img src="assets/img/inner-bg2.png" className="img-fluid" alt="alt" />
          <div className="container">
            <div className="section-main-heading2">
              <h4 className="fontSizeClass"> {t("BSUP")} </h4>
            </div>
          </div>
        </div>
      </section>
      {/* End Slider */}

      <section className="section inner-pad1">
        <div className="container ">
          <div className="row">
            <div className="col-lg-3">
              <div className="site-menu">
                <nav className="sidebar card py-2">
                  <ul className="nav flex-column" id="nav_accordion">
                    {UttaranServicesLeftMenuList.map((item, index) => (
                      <RenderNavItem item={item} index={index} t={t} />
                    ))}
                  </ul>
                </nav>
              </div>
            </div>
            <div className="col-lg-9">
              <div className="container">
                <div className="row">
                  <div className="inner-title2">
                    <h3 className="fontSizeClass"> {t("BSUP")} </h3>
                  </div>
                  <div className="about-head1">
                    <div className="dig-login1 dig-login2">
                      <form>
                        <div className="log-form inner-log-form">
                          <h3 className="fontSizeClass">
                            {t("BENIFICIARY LIST - BSUP")}
                          </h3>
                          <div className="row">
                            <div className="col-md-12 map2">
                              <a
                                type="button"
                                className="btn "
                                data-toggle="collapse"
                                data-target="#demo"
                              >
                                {t("PACKAGE")} - I
                                <i className="bi bi-chevron-down ml-3" />
                              </a>
                              <div id="demo" className="collapse">
                                <div className="mayor-table health-dept-table">
                                  <table
                                    width="100%"
                                    border={0}
                                    align="center"
                                    cellPadding={2}
                                    cellSpacing={2}
                                    className="table table-bordered officials"
                                  >
                                    <tbody>
                                      <tr
                                        bgcolor="#302ba0"
                                        align="center"
                                        valign="middle"
                                      >
                                        <td
                                          width="100%"
                                          className="text-white tble-brder-left"
                                        >
                                          {t("KACHARIPARA")}
                                        </td>
                                      </tr>
                                      {[
                                        {
                                          fileStoreId: "d3d51f71-72aa-459d-8fb6-191f7f9958e1",
                                          label: "1 - 249",
                                        },
                                        {
                                          fileStoreId: "128dc895-d597-4f1f-8c1e-8990d9a78928",
                                          label: "250 - 429",
                                        },
                                        {
                                          fileStoreId: "0bf7cdc8-ae41-4fbe-8bac-e2ad39f0fd05",
                                          label: "430 - 529",
                                        },
                                        {
                                          fileStoreId: "ba28d265-18d3-49a7-9874-6f8b6cb7da36",
                                          label: "530 - 759",
                                        },
                                        {
                                          fileStoreId: "cdaff306-e451-4099-8b77-264af8234714",
                                          label: "760 - 864 & 1 - 94",
                                        },
                                        {
                                          fileStoreId: "bf89af56-e004-455d-ad18-5d12685dc599",
                                          label: "Shop Owners",
                                        },
                                      ].map(({ fileStoreId, label }, index) => (
                                        <tr key={index}>
                                          <td>
                                            <DownloadFileByFileStoreId
                                              fileStoreId={fileStoreId}
                                              label={label}
                                            />
                                          </td>
                                        </tr>
                                      ))}
                                    </tbody>
                                  </table>
                                  <br />
                                  <table
                                    width="100%"
                                    border={0}
                                    align="center"
                                    cellPadding={2}
                                    cellSpacing={2}
                                    className="table table-bordered officials"
                                  >
                                    <tbody>
                                      <tr
                                        bgcolor="#302ba0"
                                        align="center"
                                        valign="middle"
                                      >
                                        <td
                                          width="100%"
                                          className="text-white tble-brder-left"
                                        >
                                          {t("RAJARGHAT")}
                                        </td>
                                      </tr>
                                      {[
                                        {
                                          fileStoreId: "5b097870-f99a-4881-9379-595d950fa232",
                                          label: "1 - 142",
                                        },
                                        {
                                          fileStoreId: "c5058641-e412-4a0d-b415-d634e3f985de",
                                          label: "143 - 393",
                                        },
                                        {
                                          fileStoreId: "f42f8103-f624-4027-b95c-81fba1050530",
                                          label: "394 - 623",
                                        },
                                        {
                                          fileStoreId: "1cc2f853-6756-4ac0-a594-26811c844ef9",
                                          label: "624 - 947",
                                        },
                                        {
                                          fileStoreId: "998ac9dd-0d89-4d4b-903c-ff2f9ada31a1",
                                          label: "948 - 1152",
                                        },
                                        {
                                          fileStoreId: "cc411489-2130-4743-a6a6-d88cf9a3fc7b",
                                          label: "1153 - 1327",
                                        },
                                        {
                                          fileStoreId: "0768bf12-bfbc-4fa5-8313-3e687b59a598",
                                          label: "1328 - 1479",
                                        },
                                        {
                                          fileStoreId: "059c155b-2d72-4eb7-9851-86d0efe770c4",
                                          label: "1480 - 1704",
                                        },
                                        {
                                          fileStoreId: "268d19ef-9bf6-45b9-8f08-65b426cce79f",
                                          label: "1705 - 1813",
                                        },
                                        {
                                          fileStoreId: "81036f0b-5ac8-4245-b5e0-74cb0c492e83",
                                          label: "1814 - 1901",
                                        },
                                        {
                                          fileStoreId: "f6dc1564-f473-45ef-9f27-fc410ba1a65c",
                                          label: "1902 - 2050",
                                        },
                                        {
                                          fileStoreId: "be43df59-2e36-46ad-a92a-8cb312331c57",
                                          label: "2051 - 2181",
                                        },
                                        {
                                          fileStoreId: "97a54517-ba7f-476d-9a16-bc978011db71",
                                          label: "2182 - 2313",
                                        },
                                        {
                                          fileStoreId: "79807fd0-b68f-47f5-b119-52a29de349ea",
                                          label: "2314 - 2488",
                                        },
                                        {
                                          fileStoreId: "00040d17-a71d-4419-8a9f-1feae95db470",
                                          label: "2489 - 2613",
                                        },
                                      ].map(({ fileStoreId, label }, index) => (
                                        <tr key={index}>
                                          <td>
                                            <DownloadFileByFileStoreId
                                              fileStoreId={fileStoreId}
                                              label={label}
                                            />
                                          </td>
                                        </tr>
                                      ))}
                                    </tbody>
                                  </table>
                                  <br />
                                  <table
                                    width="100%"
                                    border={0}
                                    align="center"
                                    cellPadding={2}
                                    cellSpacing={2}
                                    className="table table-bordered officials"
                                  >
                                    <tbody>
                                      <tr
                                        bgcolor="#302ba0"
                                        align="center"
                                        valign="middle"
                                      >
                                        <td
                                          width="100%"
                                          className="text-white tble-brder-left"
                                        >
                                          HATGACHIA
                                        </td>
                                      </tr>
                                      <tr>
                                        <td>
                                          <DownloadFileByFileStoreId
                                            fileStoreId={"0e2e6996-c598-48e1-a1f5-b8d489e56332 "}
                                            label={"1 - 727"}
                                          />
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                  <br />
                                </div>
                              </div>
                            </div>
                            <div className="col-md-12 map2">
                              <a
                                type="button"
                                className="btn"
                                data-toggle="collapse"
                                data-target="#demo1"
                              >
                                PACKAGE - II
                                <i className="bi bi-chevron-down  ml-3" />
                              </a>
                              <div id="demo1" className="collapse">
                                <div className="card-body m-3 fontSizeClass">
                                  <table
                                    width="100%"
                                    border={0}
                                    align="center"
                                    cellPadding={2}
                                    cellSpacing={2}
                                    className="table table-bordered officials"
                                  >
                                    <tbody>
                                      <tr
                                        bgcolor="#302ba0"
                                        align="center"
                                        valign="middle"
                                      >
                                        <td
                                          width="100%"
                                          className="text-white tble-brder-left"
                                        >
                                          ANANDA NAGAR
                                        </td>
                                      </tr>
                                      <tr>
                                        <td>
                                          <DownloadFileByFileStoreId
                                            fileStoreId={"35ba80a2-4429-4cf0-b798-a9c066fc1dcd "}
                                            label={"1 - 90"}
                                          />
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                  <br />
                                  <table
                                    width="100%"
                                    border={0}
                                    align="center"
                                    cellPadding={2}
                                    cellSpacing={2}
                                    className="table table-bordered officials"
                                  >
                                    <tbody>
                                      <tr
                                        bgcolor="#302ba0"
                                        align="center"
                                        valign="middle"
                                      >
                                        <td
                                          width="100%"
                                          className="text-white tble-brder-left"
                                        >
                                          JALPARA
                                        </td>
                                      </tr>
                                      <tr>
                                        <td>
                                          <DownloadFileByFileStoreId
                                            fileStoreId={"4cbae0cf-0948-44ea-8989-7bad4c1c5314"}
                                            label={"1 - 218"}
                                          />
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                  <br />
                                  <table
                                    width="100%"
                                    border={0}
                                    align="center"
                                    cellPadding={2}
                                    cellSpacing={2}
                                    className="table table-bordered officials"
                                  >
                                    <tbody>
                                      <tr
                                        bgcolor="#302ba0"
                                        align="center"
                                        valign="middle"
                                      >
                                        <td
                                          width="100%"
                                          className="text-white tble-brder-left"
                                        >
                                          GARDENRICH
                                        </td>
                                      </tr>
                                      {[
                                        {
                                          fileStoreId: "312dcb56-f23d-4719-82c6-b16aa21ef3e8",
                                          label: "1 - 219",
                                        },
                                        {
                                          fileStoreId: "e08d0397-8ea4-4613-a67a-a4ae61511d3c",
                                          label: "220 - 417",
                                        },
                                        {
                                          fileStoreId: "940e7617-01e8-4a58-bfbc-2834a422003d",
                                          label: "418 - 594",
                                        },
                                        {
                                          fileStoreId: "e590deef-f486-4619-88f8-c3322136f304",
                                          label: "595 - 739",
                                        },
                                      ].map(({ fileStoreId, label }, index) => (
                                        <tr key={index}>
                                          <td>
                                            <DownloadFileByFileStoreId
                                              fileStoreId={fileStoreId}
                                              label={label}
                                            />
                                          </td>
                                        </tr>
                                      ))}
                                    </tbody>
                                  </table>
                                  <br />
                                </div>
                              </div>
                            </div>
                            <div className="col-md-12 map2">
                              <a
                                type="button"
                                className="btn"
                                data-toggle="collapse"
                                data-target="#demo2"
                              >
                                {t("PACKAGE")} - III
                                <i className="bi bi-chevron-down ml-3" />
                              </a>
                              <div id="demo2" className="collapse">
                                <div className="mayor-table health-dept-table">
                                  <table
                                    width="100%"
                                    border={0}
                                    align="center"
                                    cellPadding={2}
                                    cellSpacing={2}
                                    className="table table-bordered officials"
                                  >
                                    <tbody>
                                      <tr
                                        bgcolor="#302ba0"
                                        align="center"
                                        valign="middle"
                                      >
                                        <td
                                          width="100%"
                                          className="text-white tble-brder-left"
                                        >
                                          PAGLADANGA - I
                                        </td>
                                      </tr>
                                      {[
                                        { fileStoreId: "f0269670-f7fb-4199-9f0b-c4aad36c27e4", label: "1 - 87" },
                                        {
                                          fileStoreId: "a1793cb5-a3c7-4b8f-a811-31adef305dd4",
                                          label: "88 - 174",
                                        },
                                        {
                                          fileStoreId: "42238df6-b28f-4901-a204-a3df126f316f",
                                          label: "175 - 293",
                                        },
                                        {
                                          fileStoreId: "919ac402-eff0-4ae5-9680-9c53ddf7f8d4",
                                          label: "294 - 380",
                                        },
                                        {
                                          fileStoreId: "c13706df-e1cf-47e2-a472-acbbda89e6e6",
                                          label: "381 - 467",
                                        },
                                        {
                                          fileStoreId: "93f27783-671e-459e-80ae-4d90c379bd0a",
                                          label: "468 - 582",
                                        },
                                      ].map(({ fileStoreId, label }, index) => (
                                        <tr key={index}>
                                          <td>
                                            <DownloadFileByFileStoreId
                                              fileStoreId={fileStoreId}
                                              label={label}
                                            />
                                          </td>
                                        </tr>
                                      ))}
                                    </tbody>
                                  </table>
                                  <br />
                                  <table
                                    width="100%"
                                    border={0}
                                    align="center"
                                    cellPadding={2}
                                    cellSpacing={2}
                                    className="table table-bordered officials"
                                  >
                                    <tbody>
                                      <tr
                                        bgcolor="#302ba0"
                                        align="center"
                                        valign="middle"
                                      >
                                        <td
                                          width="100%"
                                          className="text-white tble-brder-left"
                                        >
                                          BANERJEE PARA
                                        </td>
                                      </tr>
                                      <tr>
                                        <td>
                                          <DownloadFileByFileStoreId
                                            fileStoreId={"ed1ae372-a042-4fa9-a439-3f44a07030c9"}
                                            label={"1 - 32"}
                                          />
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                  <br />
                                  <table
                                    width="100%"
                                    border={0}
                                    align="center"
                                    cellPadding={2}
                                    cellSpacing={2}
                                    className="table table-bordered officials"
                                  >
                                    <tbody>
                                      <tr
                                        bgcolor="#302ba0"
                                        align="center"
                                        valign="middle"
                                      >
                                        <td
                                          width="100%"
                                          className="text-white tble-brder-left"
                                        >
                                          SENPALLY
                                        </td>
                                      </tr>
                                      <tr>
                                        <td>
                                          <DownloadFileByFileStoreId
                                            fileStoreId={"5b74182f-0c21-4d29-9182-a22f59201a36"}
                                            label={"1 - 32"}
                                          />
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default BSUP;
